module.exports = __webpack_public_path__ + "img/hr-dry-dirt.0ec1a371.png";